"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _app = require("@package/app");

var _profile = require("@widget/profile");

var _utils = require("@package/utils");

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _Card = _interopRequireDefault(require("./Card"));

var _classnames = _interopRequireDefault(require("classnames"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function TableComponent(_ref) {
  var items = _ref.items,
      shopsInProcess = _ref.shopsInProcess,
      onModeration = _ref.onModeration;

  try {
    var _useSelector = (0, _reactRedux.useSelector)(_profile.selectProfile),
        permissions = _useSelector.user.permissions;

    var hasPermissionUpdate = (0, _utils.checkPermission)(permissions, 'shop.get');
    var isPermissionToModerate = (0, _utils.checkPermission)(permissions, 'shop.status.tomoderation');
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['table'],
      "data-locator": 'table.shops'
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['thead']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['th']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])(_defaultModule["default"]['td'], _defaultModule["default"]['status']),
      "data-location": 'table.shops.header.col[0].status'
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])(_defaultModule["default"]['td'], _defaultModule["default"]['name'])
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: _defaultModule["default"]['title'],
      "data-location": 'table.shops.header.col[1].shopID'
    }, "\u041C\u0430\u0433\u0430\u0437\u0438\u043D/ID")), /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])(_defaultModule["default"]['td'], _defaultModule["default"]['url'])
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: _defaultModule["default"]['title'],
      "data-location": 'table.shops.header.col[2].website'
    }, "\u0421\u0430\u0439\u0442 \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0430")), /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])(_defaultModule["default"]['td'], _defaultModule["default"]['status-2'])
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: _defaultModule["default"]['title'],
      "data-location": 'table.shops.header.col[3].status-2'
    }, "\u0421\u0442\u0430\u0442\u0443\u0441")), isPermissionToModerate && /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])(_defaultModule["default"]['td'], _defaultModule["default"]['status-3'])
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: _defaultModule["default"]['title'],
      "data-location": 'table.shops.header.col[4].status-3'
    })), hasPermissionUpdate && /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])(_defaultModule["default"]['td'], _defaultModule["default"]['control']),
      "data-location": 'table.shops.header.col[5].control'
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['tbody']
    }, !items['length'] && /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['tr'],
      "data-location": 'table.shops.empty'
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: (0, _classnames["default"])(_defaultModule["default"]['td'], _defaultModule["default"]['empty'])
    }, "\u041D\u0435\u0442 \u0434\u0430\u043D\u043D\u044B\u0445")), items.map(function (shop, index) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: shop['id'],
        className: _defaultModule["default"]['card'],
        "data-locator": "table.shops.row[".concat(index, "]")
      }, /*#__PURE__*/_react["default"].createElement(_Card["default"], Object.assign({}, shop, {
        shopsInProcess: shopsInProcess,
        onModeration: onModeration,
        rowIndex: index
      })));
    })));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = TableComponent;
exports["default"] = _default;